




















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import Localization from '@/service/localization'
import { IProject } from './Localization.vue'

@Component({
  name: 'c-add-key-dialog'
})
export default class AddKeyDialog extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Object) project!: IProject

  description: string | null = null
  section: string | null = null
  key: string | null = null
  ru: string | null = null
  en: string | null = null
  de: string | null = null

  get canSend (): boolean {
    return (
      !!this.key &&
      !!this.description &&
      !!this.section &&
      !!this.ru &&
      !!this.en &&
      !!this.de
    )
  }

  get show (): boolean {
    return this.value
  }

  set show (value: boolean) {
    this.$emit('input', value)
  }

  @Watch('show')
  onShowChanged (newVal: boolean) {
    if (newVal == false) {
      this.description = null
      this.section = null
      this.key = null
      this.ru = null
      this.en = null
      this.de = null
    }
  }

  protected addKey() {
    const newKey = {
      description: this.description,
      section: this.section,
      key: this.key,
      ru: this.ru,
      en: this.en,
      de: this.de
    }
    const projectId = this.project._id || null

    this.show = false

    if (projectId) {
      Localization.addKey(projectId, newKey).then(res => {
        if (res == true) {
          this.$emit('update-projects')
        }
      })
    } else {
      console.warn('projectId не существует...')
    }
  }

  protected cancel() {
    this.show = false
  }
}
